export const ledgerEventTypes = [
  { id: 1, name: 'Procedure' },
  { id: 2, name: 'Encounter' },
  { id: 3, name: 'Status' },
  { id: 4, name: 'Expense - Fixed' },
  { id: 5, name: 'Expense - Variable' },
  { id: 6, name: 'Patient Stipend' },
  { id: 7, name: 'Patient Reimbursement' }
];
